import React from 'react';
import { Box } from '@mui/material';
import BannerCarousel from '../../Components/BannerCarousel';
import { BannerTemplateRenderer } from './BannerTemplates';

const BannerSlider = ({ sliders }) => (
  <Box sx={{ overflow: 'hidden' }}>
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      maxWidth: {
        xs: '620px',
        sm: '930px',
        md: '1240px',
        lg: '1240px',
        xl: '1550px',
      },
      width: 'fit-content',
      overflowX: 'scroll',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
    }}>
      <BannerCarousel
        items={sliders}
        containerSx={{ width: '100%', scrollbarWidth: 'none' }}
        renderItem={(slide, idx) => (
          <Box key={idx} sx={{ pr: 1, width: '300px' }}>
            <Box sx={{
              borderRadius: 2,
              overflow: 'hidden',
              cursor: 'pointer',
              position: 'relative',
            }}>
              <BannerTemplateRenderer slide={slide} />
            </Box>
          </Box>
        )}
      />
    </Box>
  </Box>
);

export default BannerSlider;
